export const GET_APPREHENDING_OFFICERS = 'APPREHENDING_OFFICERS/GET_APPREHENDING_OFFICERSs';
export const GET_SINGLE_APPREHENDING_OFFICER = 'APPREHENDING_OFFICERS/get_single_apprehending_officer';
export const UPDATE_APPREHENDING_OFFICER = 'APPREHENDING_OFFICERS/update_apprehending_officer';
export const CREATE_APPREHENDING_OFFICER = 'APPREHENDING_OFFICERS/create_apprehending_officer';
export const REMOVE_APPREHENDING_OFFICER = 'APPREHENDING_OFFICERS/remove_apprehending_officer';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  name: '',
};
